import createIcon from '../../createIcon';

/**
 * @component @name KeyboardDoubleArrowUp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxNy41OUw3LjQxIDE5TDEyIDE0LjQyTDE2LjU5IDE5TDE4IDE3LjU5TDEyIDExLjU5TDYgMTcuNTlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNiAxMUw3LjQxIDEyLjQxTDEyIDcuODNMMTYuNTkgMTIuNDFMMTggMTFMMTIgNUw2IDExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardDoubleArrowUp = createIcon('KeyboardDoubleArrowUp', [
  ['path', { d: 'M6 17.59L7.41 19L12 14.42L16.59 19L18 17.59L12 11.59L6 17.59Z', key: 'psxu7c' }],
  ['path', { d: 'M6 11L7.41 12.41L12 7.83L16.59 12.41L18 11L12 5L6 11Z', key: 'l3gh0k' }],
]);

export default KeyboardDoubleArrowUp;
